export const FETCH_MEDIA_SUCCESS = "FETCH_MEDIA_SUCCESS";
